// @flow

import * as React from 'react';
import {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import Box from 'sail/Box';
import {ButtonLink} from 'sail/Button';
import Icon from 'sail/Icon';
import {MenuGroup, MenuItem} from 'sail/Menu';
import MenuContainer from 'sail/MenuContainer';
import {AlignBox} from 'sail/Align';
import {BodyTextProps} from 'sail/Text';

type RefDropdownMenuItemProps = {|
  href: string,
  label: string,
  icon?: string,
|};

const RefDropdownMenuItem = ({href, label, icon}: RefDropdownMenuItemProps) => (
  <MenuItem href={href} openInNewWindow>
    <AlignBox reference={BodyTextProps}>
      {label}
      {icon && (
        <Box margin={{left: 4}}>
          {/* $FlowExpectedError icon wants a specific string but we just have a generic one */}
          <Icon icon={icon} size={10} color="inherit" />
        </Box>
      )}
    </AlignBox>
  </MenuItem>
);

const RefDropdownMenu = () => {
  return (
    <Box padding={{vertical: 8}}>
      <MenuGroup>
        <RefDropdownMenuItem label="API" href="/docs/api" />
        <RefDropdownMenuItem label="Stripe.js" href="/docs/js" />
        <RefDropdownMenuItem label="CLI" href="/docs/cli" />
      </MenuGroup>
      <RefDropdownMenuItem
        label="iOS"
        href="https://stripe.dev/stripe-ios/docs"
        icon="external"
      />
      <RefDropdownMenuItem
        label="Android"
        href="https://stripe.dev/stripe-android"
        icon="external"
      />
      <RefDropdownMenuItem
        label="React Native"
        href="https://stripe.dev/stripe-react-native"
        icon="external"
      />
    </Box>
  );
};

export const RefDropdown = () => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <MenuContainer
      contextMeetingPoint="bottom"
      layerMeetingPoint="top"
      contents={<RefDropdownMenu />}
      showMenu={showMenu}
      onMenuStateChange={(value) => {
        setShowMenu(value);
      }}
      offsetY={-3}
    >
      <RefLink showMenu={showMenu} setShowMenu={setShowMenu} />
    </MenuContainer>
  );
};

const RefLink = ({showMenu, setShowMenu}) => {
  return (
    <ButtonLink
      label={
        <FormattedMessage
          id="docsShell.refdropdown.label"
          description="A dropdown label that contains links to APIs and SDKs"
          defaultMessage="APIs & SDKs"
        />
      }
      size="medium"
      icon={showMenu ? 'chevronUp' : 'chevronDown'}
      iconPosition="right"
      color="gray700"
      onClick={() => {
        setShowMenu(!showMenu);
      }}
    />
  );
};
